export default {
  spacing: {
    "&> * + *": {
      marginLeft: "16px !important"
    }
  }
};
